import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMoneyBillWave, 
  faClock, 
  faFileSignature, 
  faHandshake, 
  faPercent, 
  faShieldAlt 
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const FeaturesSection = styled.section`
  padding: 100px 0;
  background-color: #f9f9f9;
  
  .section-title {
    text-align: center;
    margin-bottom: 70px;
    
    h2 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #333;
      margin-bottom: 20px;
      
      span {
        color: #2e7d32;
      }
    }
    
    p {
      color: #666;
      font-size: 1.1rem;
      max-width: 700px;
      margin: 0 auto;
    }
  }
  
  .feature-card {
    height: 100%;
    border: none;
    border-radius: 15px;
    padding: 30px 25px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    text-align: center;
    background-color: #fff;
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    }
    
    .feature-icon {
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 25px;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      color: #2e7d32;
      font-size: 2rem;
      transition: all 0.3s ease;
    }
    
    .card-title {
      font-weight: 700;
      font-size: 1.3rem;
      margin-bottom: 15px;
      color: #333;
    }
    
    .card-text {
      color: #666;
      font-size: 1rem;
      line-height: 1.6;
    }
    
    &:hover .feature-icon {
      background-color: #fff;
      color: #2e7d32;
      transform: rotateY(360deg);
      transition: transform 0.8s ease, background-color 0.3s ease, color 0.3s ease;
    }
  }
`;

const Features = () => {
  const features = [
    {
      icon: faMoneyBillWave,
      title: "Fast Cash Offers",
      description: "Get a fair cash offer for your land within 24-48 hours, no matter the condition or location."
    },
    {
      icon: faClock,
      title: "Quick Closing",
      description: "Close on your timeline — as quickly as 14 days or whenever you're ready to sell your property."
    },
    {
      icon: faFileSignature,
      title: "Simple Process",
      description: "Our streamlined process eliminates the typical complications of selling land, making it hassle-free."
    },
    {
      icon: faHandshake,
      title: "Direct Buyers",
      description: "We buy directly from you — no agents, no middlemen, no delays in the purchasing process."
    },
    {
      icon: faPercent,
      title: "No Fees or Commissions",
      description: "Keep more money in your pocket with zero commissions, closing costs, or hidden fees."
    }
  ];

  return (
    <FeaturesSection id="features">
      <Container>
        <div className="section-title">
          <h2>Why Sell Your Land to <span>Us</span></h2>
          <p>
            We make selling your land simple, fast, and stress-free.
          </p>
        </div>
        
        <Row className="g-4 justify-content-center">
          {features.map((feature, index) => (
            <Col key={index} md={6} lg={4} className="col-lg-4">
              <Card className="feature-card">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={feature.icon} />
                </div>
                <Card.Body>
                  <Card.Title>{feature.title}</Card.Title>
                  <Card.Text>{feature.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </FeaturesSection>
  );
};

export default Features;
